import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ContextMenuItem from '../ContextMenuItem/ContextMenuItem';

const ContextMenu = ({
  children,
  iconProps,
  labelProps,
  className,
  menuProps,
  onClick,
  options,
  optionProps
}) => (
  <div className={classnames('card text--left', className)} {...menuProps}>
    {options
      ? options.map(option => (
          <ContextMenuItem // eslint-disable-line react/jsx-indent
            {...option}
            {...optionProps}
            onClick={onClick}
            labelProps={labelProps}
            iconProps={iconProps}
            key={option.value}
          />
        )) // eslint-disable-line indent
      : children}
  </div>
);

ContextMenu.propTypes = {
  children: PropTypes.node,
  iconProps: PropTypes.object,
  labelProps: PropTypes.object,
  className: PropTypes.string,
  menuProps: PropTypes.object,
  onClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape(ContextMenu.PropTypes)),
  optionProps: PropTypes.object
};

export default ContextMenu;
